import React, {Component} from "react";

import {connect} from "react-redux";

export interface MailingListsProps {
    compareConfigurations: any[];
}

class MailingListsCompareComponent extends Component<MailingListsProps, {}> {
    renderMailingList = index => {
        return (
            <tr key={index}>
                {this.props.compareConfigurations.map(config => {
                    if (config.settings.mailing_lists[index]) {
                        const mailingLists = config.settings.mailing_lists[index];
                        return (
                            <td className="value" key={`${index}-${config.id}`}>
                                <div className="terminal-group">
                                    <div className="mailing-list-title">
                                        <span>Name</span>
                                        {mailingLists.name}
                                    </div>
                                    <div className="mailing-list-title">
                                        <span>Mailing List</span>
                                        <div className="mailing-list-items">
                                            <ul>
                                                {mailingLists.mails.map(mail => {
                                                    return (
                                                        <li key={`${index}-${config.id}-${mail.address}`}>
                                                            {mail.address}{" "}
                                                            {mail.removable
                                                                ? "(removable)"
                                                                : ""}
                                                        </li>
                                                    );
                                                })}

                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </td>
                        );
                    }
                })}
            </tr>
        )
    }

    render() {
        let rowsCount = 0;
        let hasMailingLists = false;

        this.props.compareConfigurations.map(config => {
            if (config.settings.mailing_lists.length > 0) {
                hasMailingLists = true
            }

            if (config.settings.mailing_lists.length > rowsCount) {
                rowsCount = config.settings.mailing_lists.length
            }
        })

        if (!hasMailingLists) return null;

        const groupRows = Array.from(Array(rowsCount).keys());

        return (
            <table id="table-comparative">
                <thead>
                <tr>
                    <td colSpan={this.props.compareConfigurations.length}>
                        Mailing Lists
                    </td>
                </tr>
                </thead>
                <tbody>
                {groupRows.map(index => this.renderMailingList(index))}
                </tbody>
            </table>
        )
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MailingListsCompareComponent)